import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, featureKey } from '../context/AuthContext';
import { pricingPathFor } from '../utils/featurePlans';

/**
 * Route-level entitlement guard, SERVER-AUTHORITATIVE. A caller who lacks the feature's entitlement — resolved from
 * GET /api/auth/me, not localStorage — is sent to the plans page (owner 2026-10-04: no intermediate upsell page), which
 * names the plan that includes the feature. The backend enforces the same entitlement on the page's API calls.
 */
export default function ProGate({ feature, children }: { feature?: string; children: React.ReactNode }) {
  const { loading, has } = useAuth();
  if (feature && has(featureKey(feature))) {
    return <>{children}</>;
  }
  if (loading) {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: 'var(--muted, var(--c-text-mute))', fontSize: 13 }}>
        Checking access…
      </div>
    );
  }
  return <Navigate to={pricingPathFor(feature)} replace />;
}
